export default "__VITE_ASSET__eac75b8d__"